import StorageUtils from "@/utils/storageUtils";
import EmpService from "@/api/EmpService";

const user = {
	namespaced: true,
	state: {
		userInfo: null,
		routerName:'home',
	},
	mutations: {
		updateRouterName(state,value){
			state.routerName = value;
		},
		changeUser(state, user) {
			StorageUtils.setItem('userInfo', user);
			state.userInfo = user;
		}
	},
	getters: {},
	actions: {
		upDateRouterName(context, value) {
			context.commit('updateRouterName', value);
		},
		async getUser(context, value) {
			const token= StorageUtils.getItem('token');
			if(token){
				const res = await EmpService.get();
				context.commit('changeUser', res)
				return res
			}
		}
	},
};
export default user;
